import React from 'react';

/**
 * Odoo official "O" mark — Inline SVG for use as an Ant Design-compatible icon.
 *
 * Brand guidelines (https://www.odoo.com/page/branding):
 *   - Locked color: Odoo Purple #714B67
 *   - Used here strictly for integration / interoperability identification
 *   - Trademark: Odoo and the Odoo logo are trademarks of Odoo S.A.
 *
 * The fill is locked to the brand purple and DOES NOT inherit `currentColor`,
 * so changing the surrounding `iconColor` only affects node border/hover and
 * never the logo itself. Size scales with `style.fontSize` (1em wide/tall).
 */
const OdooLogoIcon = ({ style = {}, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    aria-label="Odoo"
    style={{
      width: '1em',
      height: '1em',
      display: 'inline-block',
      verticalAlign: '-0.125em',
      ...style
    }}
    {...rest}
  >
    <rect width="64" height="64" rx="14" ry="14" fill="#714B67" />
    <g fill="#FFFFFF">
      <path d="M32 14a18 18 0 1 0 0 36 18 18 0 0 0 0-36zm0 8a10 10 0 1 1 0 20 10 10 0 0 1 0-20z" />
      <circle cx="46" cy="20" r="4" />
    </g>
  </svg>
);

export default OdooLogoIcon;
